<div class="unauthorised d-flex flex-column justify-content-center align-items-center">
  <div class="circle d-flex justify-content-center align-items-center">
    <span class="icon-x-circle"></span>
  </div>
  <span class="access-denied" i18n>Access Denied</span>
  <span class="message" i18n>You are not authorized to access the page, please contact the system administrator.</span>
  <!-- <span class="re-direct">Redirect to Login screen</span> -->
</div>